module.exports = __webpack_public_path__ + "illumination_displays_logo.png";